export {
  synthesizeOptionChildren,
  OPTION_CHILD_COMPONENT_TYPES,
} from './optionChildren';
